import React, { useEffect } from 'react'
import {BrowserRouter, Routes, Route, Outlet, useLocation} from 'react-router-dom';
import "./styles.css";
import SideNav from './sideNav';
import TopBar from './topBar';
const Nav = () => {

    useEffect(() => {
        console.log('script working.')
       
    }, [])
  return (
    <div className=''>
       <SideNav />
        <div class="home-section">
            <TopBar page={useLocation().pathname.substring(1).toUpperCase()} />
            {console.log()}
           <div className='mt-5'>
              <Outlet />
           </div>
           
        </div>
    </div>
  )
}

export default Nav